import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import './fake.scss';
import { registerCoveoConsentBridge } from '@platform/utils/coveoConsent';

registerCoveoConsentBridge();

// ensure there is a wrapper for the app
let appWrapper = document.getElementById("app-corp");
if (!appWrapper) {
  appWrapper = document.createElement("div");
  appWrapper.id = "app-corp";
  document.querySelector("body").appendChild(appWrapper);
}

const DcApp = createApp(App);
DcApp.use(store);
DcApp.use(ElementPlus);
DcApp.mount("#app-corp");
window.store = store

window.addEventListener('OneTrustGroupsUpdated', (event) => {
    store.dispatch('user/updatePrivacyPreferences', event.detail);
    store.dispatch('search/updateAnalyticsConsent');
});

if (window.OnetrustActiveGroups) {
    store.dispatch('user/updatePrivacyPreferences', window.OnetrustActiveGroups)
}

